import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useEntityIdParam } from '../../hooks/useEntityIdParam';
import { useSMLDatePickerDateParam } from '../../hooks/useSMLDatePickerDateParam';
import { useSMLCountryParam } from '../../hooks/useSMLCountryParam';
import { useArtistPlaylistScoreChart } from '../../hooks/useArtistPlaylistScoreChart';
import { PlaylistScoreChart } from '../PlaylistScoreChart/PlaylistScoreChart';

interface ArtistPlaylistScoreChartProps {
  // No props needed - component will use hooks directly
}

const ArtistPlaylistScoreChartComponent: React.FC<ArtistPlaylistScoreChartProps> = () => {
  const intl = useIntl();
  const artistId = useEntityIdParam('artist');
  const { selectedDate, rangeDays } = useSMLDatePickerDateParam();
  const { countryCode } = useSMLCountryParam();

  const {
    data: scoreData,
    isLoading,
    error,
  } = useArtistPlaylistScoreChart({
    artistId: artistId || '',
    date: selectedDate,
    rangeDays,
  });

  const data = React.useMemo(() => scoreData?.data || [], [scoreData?.data]);
  const dateRange = scoreData?.dateRange;

  const title = intl.formatMessage({
    id: 'app.sml.artist.details.playlist-score',
    defaultMessage: 'Playlist Score',
  });

  return (
    <>
      <PlaylistScoreChart title={title} data={data} dateRange={dateRange} isLoading={isLoading} error={error} />
      {countryCode !== undefined && (
        <span className="text-muted small">
          {intl.formatMessage({
            id: 'app.sml.artist.details.scoreChartGlobalNote',
            defaultMessage: 'Score is calculated worldwide',
          })}
        </span>
      )}
    </>
  );
};

export const ArtistPlaylistScoreChart = TypedMemo(ArtistPlaylistScoreChartComponent);
